<template>
  <div class="relative" ref="dropdown">
    <button
      class="flex items-center ml-2 focus:outline-none menu-button"
      @click="isMenuOpen = true"
    >
      <avatar
        class="avatar shadow-md border-2 border-white"
        :size="35"
        :src="this.avatar_url"
        :username="this.username"
      >
      </avatar>
      <span class="ml-1">
        <simple-svg
          :filepath="DownIcon"
          :width="'20px'"
          :height="'20px'"
          class="arrow"
        />
      </span>
    </button>

    <transition name="comeIn">
      <nav
        v-show="isMenuOpen"
        class="absolute z-30 bg-white rounded-lg shadow-lg w-56 right-0 px-1 py-2 mt-2 border border-gray-200"
      >
        <slot name="menu-items"></slot>
      </nav>
    </transition>

    <button
      v-if="isMenuOpen"
      class="block w-full h-full fixed inset-0 opacity-0 z-20 cursor-default"
      @click="isMenuOpen = false"
    ></button>
  </div>
</template>

<script>
import DownIcon from "./images/icons/chevron-down.svg";

export default {
  props: ["avatar_url", "username"],
  data() {
    return {
      isMenuOpen: false,
      DownIcon,
    };
  },

  mounted() {
    this.$refs.dropdown
      .getElementsByClassName("menu-items")[0]
      .classList.remove("hidden");
  },
};
</script>

<style>
.menu-button:focus .avatar {
  box-shadow: 0 0 2px 2px theme("colors.red.500");
}

.menu-button:focus .arrow {
  color: theme("colors.red.500");
}

.dropdown__item {
  @apply flex py-1 px-2 mb-1 rounded transition duration-150 ease-in-out;
}

.dropdown__item:last-child {
  @apply mb-0;
}

a.dropdown__item:hover,
a.dropdown__item:focus {
  @apply bg-gray-200;
}

.dropdown__item__icon {
  @apply w-4 mr-2;
}

.comeIn-enter,
.comeIn-leave-to {
  opacity: 0;
  transform: scale(0.98) translateY(-2rem);
}

.comeIn-enter-to,
.comeIn-leave {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.comeIn-enter-active,
.comeIn-leave-active {
  transition: all 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
